export const SITE_PREFERENCES_TOOL_TITLE = 'Site Preferences'
export const INSTRUCTIONS = `Select an Excel spreadsheet (.csv or .xlsx) for updating site preferences values. (.xls not supported)`

export const BROWSE = 'Browse'
export const UPLOAD = 'Upload'

export const DOWNLOAD_RESULTS_LINK_LABEL = 'Download Results'
export const TOOL_DESCRIPTION = `For each row of the uploaded spreadsheet, this tool will update the informed 
site Preferences values for the specified site.`

export const FIELD_DESCRIPTION_HS_IMPLEMENTATION_LEVEL =
  'Implementation Level for this Site. For High School, values are 1 or 2'
export const FIELD_DESCRIPTION_HS_IMPLEMENTATION_TYPE =
  'How widely this site is implementing the High School program. Values are “pilot” or “schoolwide”'
export const FIELD_DESCRIPTION_HS_IS_LAUNCHED =
  'Was the program already launched for High School. Values are Yes or No'
export const FIELD_DESCRIPTION_HS_STUDENT_ACTIVITIES =
  'Are Student Activities enabled for the High School program at this site. Values are Yes or No'
export const FIELD_DESCRIPTION_MS_BULLYING_OPT =
  'Has this Middle School opted in to teach the bullying and harassment unit.'
export const FIELD_DESCRIPTION_SITE_ID =
  'The Id of the site having its preferences updated'



// WEBPACK FOOTER //
// ./src/containers/css-admin/sitePreferences/constants.js